import { REFERRER_STORAGE_KEY } from 'src/constants/sessionStorage';
import { AccountType } from 'src/graphql/lib/server-types';
import { safeSessionStorage } from 'src/lib/browserStorage';
import { getOrganizationLinkId } from '../CoordinatorDashboard/organizationLink';
import { handleAuthenticatedExternalAuthRedirect } from './externalAuthHelpers';

const LOGIN_RETURN_PATHS = new Set(['/', '/login', '/sso', '/auth/google']);

export const getLoginReferrerLink = (
    referrer: { pathname: string; search?: string; hash?: string } | null | undefined,
    storedReferrer: string | null,
): string =>
    referrer
        ? `${referrer.pathname}${referrer.search ?? ''}${referrer.hash ?? ''}`
        : (storedReferrer ?? '');

export const handleAuthenticatedLoginRedirect = (accountType: AccountType): boolean => {
    if (handleAuthenticatedExternalAuthRedirect()) {
        return true;
    }

    if (
        (accountType !== AccountType.Coordinator && accountType !== AccountType.ControlCenter) ||
        !LOGIN_RETURN_PATHS.has(window.location.pathname)
    ) {
        return false;
    }

    // Google/SSO returns to the app root without running LoginForm's completion.
    // Restore the saved link so RCC's existing owner impersonation route can run.
    const target =
        new URLSearchParams(window.location.search).get('next') ||
        safeSessionStorage.getItem(REFERRER_STORAGE_KEY);
    const pathname = target?.split(/[?#]/, 1)[0];
    if (
        !target?.startsWith('/') ||
        !pathname ||
        LOGIN_RETURN_PATHS.has(pathname) ||
        !getOrganizationLinkId(pathname)
    ) {
        return false;
    }

    safeSessionStorage.removeItem(REFERRER_STORAGE_KEY);
    window.location.replace(target);
    return true;
};
